var map = {
	"./complete_sound (1).mp3": 2897,
	"./complete_sound (10).mp3": 7953,
	"./complete_sound (11).mp3": 7390,
	"./complete_sound (12).mp3": 7863,
	"./complete_sound (13).mp3": 7316,
	"./complete_sound (2).mp3": 9172,
	"./complete_sound (3).mp3": 8551,
	"./complete_sound (4).mp3": 1754,
	"./complete_sound (5).mp3": 2269,
	"./complete_sound (6).mp3": 2752,
	"./complete_sound (7).mp3": 9411,
	"./complete_sound (8).mp3": 70,
	"./complete_sound (9).mp3": 9161
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2589;